var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"id":"settings-button","type":"button"},on:{"click":_vm.onClick}},[_c('IconCog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }